import { createFileRoute } from '@tanstack/react-router';
import {
  PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
  PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
  PERMISSION_ONLINE_MAP_TEMPLATES_SYSTEM,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';
import OnlinePanel from '../../components/OnlinePanel';

// `add_` (trailing underscore) keeps the URL `/online_panel/templates/add/copy/$id` but opts
// this route OUT of nesting under `online_panel.templates.add` — that route renders the plain
// "add" form with no <Outlet />
export const Route = createFileRoute('/_authenticated/online_panel/templates/add_/copy/$id')({
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [
        PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
        PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
        PERMISSION_ONLINE_MAP_TEMPLATES_SYSTEM,
      ],
      ['create'],
      '/unauthorized',
      context
    );
    return {
      ...context,
      documentTitle: {
        main: 'table.copyAsNew',
        suffix: 'menu.onlinePanel',
      },
    };
  },
  component: RouteView, // eslint-disable-line @typescript-eslint/no-use-before-define
});

function RouteView() {
  const { id } = Route.useParams();

  return <OnlinePanel mode="copy" copyId={Number(id)} />;
}
